import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, catchError, map, mergeMap } from 'rxjs';
import { quizQuestionsActions } from '../actions/quiz-questions.actions';
import { HttpService } from '../services/http.service';
import { finalizeLoader } from '@app/shared/components';

@Injectable()
export class QuizQuestionsEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getQuizQuestions$ = createEffect(() => {
        return this.actions.pipe(
            ofType(quizQuestionsActions.getQuizQuestions),
            mergeMap(({ value }) => {
                return this.httpService.getQuizQuestions(value).pipe(
                    finalizeLoader('quiz-questions-list'),
                    map(({ payload, total }) => quizQuestionsActions.getQuizQuestionsSuccess({ payload, total })),
                    catchError((response: HttpErrorResponse) => of(quizQuestionsActions.getQuizQuestionsError({ code: response.status }))),
                );
            }),
        );
    });
}
